import { useClientSWR } from 'context/AuthContext/AuthContext';

interface AccountFlags {
  refunds: {
    enabled: boolean;
    options: {
      completedItemDigitalWalletRefunds: boolean;
      completedItems: boolean;
    };
  };
  partialRefunds: {
    enabled: boolean;
  };
  subWallets: {
    enabled: boolean;
  };
}

// Custom hook to fetch account feature flags
function useAccountFlags() {
  const { data, error } = useClientSWR<AccountFlags>(`platform/config`);

  const processedFlags = (() => {
    if (!data) {
      return [];
    }

    const features: Array<{
      flag: string;
      description: string;
      enabled: boolean;
    }> = [];

    if (data.refunds) {
      features.push({
        flag: 'refunds',
        description: 'Refunds feature from API',
        enabled: data.refunds.enabled,
      });
    }

    if (data.partialRefunds) {
      features.push({
        flag: 'partialRefunds',
        description: 'Partial refunds feature from API',
        enabled: data.partialRefunds.enabled,
      });
    }

    if (data.subWallets) {
      features.push({
        flag: 'subWallets',
        description: 'Subwallets feature from API',
        enabled: data.subWallets.enabled,
      });
    }

    return features;
  })();

  return {
    accountFlags: data,
    processedFlags: processedFlags,
    isError: error,
    isLoading: !data && !error,
  };
}

export default useAccountFlags;
